import { lazy } from 'react';

// Auth
export const Login = lazy(() => import('./Auth/Login'));
export const ProtectedRoute = lazy(() => import('./Auth/ProtectedRoute'));

// Layout
export const Layout = lazy(() => import('./Layout/Layout'));

// Dashboard
export const Dashboard = lazy(() => import('./Dashboard/Dashboard'));

// Students
export const StudentList = lazy(() => import('./Students/StudentList'));
export const StudentProfile = lazy(() => import('./Students/StudentProfile'));
export const StudentForm = lazy(() => import('./Students/StudentForm'));

// Cases
export const CaseList = lazy(() => import('./Cases/CaseList'));
export const CaseDetails = lazy(() => import('./Cases/CaseDetails'));

// Schools
export const SchoolList = lazy(() => import('./Schools/SchoolList'));

// Admin

export const UserManagement = lazy(() => import('./Admin/UserManagement'));
export const SchoolManagement = lazy(() => import('./Admin/SchoolManagement'));
export const SystemReports = lazy(() => import('./Admin/SystemReports'));

// Activities
export const ActivityList = lazy(() => import('./Activities/ActivityList'));

// Debug Components (Development only)
export const DeepLinkTestPage = lazy(() => import('./debug/DeepLinkTestPage'));

// Contact Us
export const ContactUs = lazy(() => import('./ContactUs'));

// Privacy Policy
export const PrivacyPolicy = lazy(() => import('./PrivacyPolicy'));

// About
export const About = lazy(() => import('./About'));
